export const PREFIX = "UI_";

export const STORE_LAYOUT = PREFIX + "STORE_LAYOUT";
export const STORE_LAYOUT_ELEMENT_LIST = PREFIX + "STORE_LAYOUT_ELEMENT_LIST";

export const FLASH_MESSAGE = PREFIX + "FLASH_MESSAGE";
export const FLASH_MESSAGE_SHOW = PREFIX + "FLASH_MESSAGE_SHOW";
export const FLASH_MESSAGE_HIDE = PREFIX + "FLASH_MESSAGE_HIDE";



// WEBPACK FOOTER //
// ./src/storeState/ui/constants.js